import { fetch } from '@maxtropy/components';

export interface ModelResponse {
  name: string;
  deviceTypeId: string;
  createSource: string;
  createByUserId: string;
}

export function getModel(id: number) {
  return fetch<{ list: ModelResponse[] }>(
    `/api/v2/model/list`,
    {
      method: 'POST',
      body: JSON.stringify({ id }),
    },
    true
  ).then(res => res.list ?? []);
}
